var _defs, _g, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDeactivated(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 156.11 51.49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1-StorageF{fill:none;stroke:#4766a4;stroke-miterlimit:10;stroke-width:2px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1-StorageF",
    d: "M8.59,38.93,56.46,10.21a3.63,3.63,0,0,1,3.71,0l53.6,31a3.73,3.73,0,0,0,1.82.49l31.92.1"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "marker",
    d: "M18,9c0,5-4,25-9,25S0,14,0,9A9,9,0,0,1,18,9Z",
    fill: "#FFF"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeactivated);
export default __webpack_public_path__ + "static/media/deactivated.24a01dd8.svg";
export { ForwardRef as ReactComponent };